import React, { 
  useState,
  useRef,
} from 'react'

import { PreviewBuilderForm } from 'src/components/PreviewBuilderForm/PreviewBuilderForm'
import { PreviewList } from 'src/components/PreviewList/PreviewList'
import { useOrderedSet } from 'src/hooks/useOrderedSet'
import { Channel } from 'src/models/Channels'
import { Domain } from 'src/models/Domain'
import { Preview } from 'src/models/Preview'

import classes from './CheckPreview.module.css'


export const placeholderPreview: Preview = {
  name: 'Untitled',
  title: 'Piar.io — No-code previews generator',
  body:
    'With Piar.io you can edit and experiment with your content then preview how your webpage will look on Facebook, Twitter, Telegram, and more!',
  image: 'https://cdn.piar.io/images/197/53mV6-preview-placeholder.png',
  link: 'https://app.piar.io',
  hash: '',
}

export const CheckPreview = () => {

  const [previewImgURL, setPreviewImgURL] = useState('')

  const [availableChannels, selectedChannels] = useOrderedSet({
    allValues: [
      Channel.linkedin,
    ],
    initiallySelectedValues: [
      Channel.linkedin,
    ],
  })

  const linkedinRef = useRef<HTMLElement | null>(null)

  const [selectedChannel, setSelectedChannel] = useState<number>()

  const channelsRefsList = [
    linkedinRef,
  ]

  const [emptyFetch, setEmptyFetch] = useState(false)

  const [domainsList, setDomainsList] = useState<Domain[]>([])

  const [selectedDomain, setSelectedDomain] = useState<Domain>()

  return (
    <>
      <div className={classes.root}>
        <div className={classes.sticky_wrapper}>
          <div
            className={classes.metadata}>
            <div className={classes.title_wrapper}>
              <div className={classes.title}>
                <h2>Check Your Preview</h2>
                <span className={classes.secondary_title}>
                  Customize your preview link
                </span>
              </div>
            </div>
            <div className={classes.form_wrapper}>
              <PreviewBuilderForm
                setEmptyFetch={setEmptyFetch}
                setPreviewImgURL={setPreviewImgURL}
                domains={domainsList}
                setSelectedDomain={setSelectedDomain}
                selectedDomain={selectedDomain}
              />
            </div>
          </div>
        </div>
        <div className={classes.preview_container}>
          <div className={classes.preview}>
            <div>
              <div className={classes.title}>
                <h2>Show Preview</h2>
                <span className={classes.secondary_title}>
                  Click on icon to show/hide preview
                </span>
              </div>
              <div className={classes.preview_content}>
                <PreviewList
                  channels={selectedChannels}
                  refsList={channelsRefsList}
                  selectedChannel={selectedChannel}
                  title={''}
                  body={''}
                  image={
                    previewImgURL.length
                      ? previewImgURL
                      : placeholderPreview.image
                  }
                  link={''}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
